function unwrapEmbed(raw: any): any {
    if (!raw) return null;
    return Array.isArray(raw) ? raw[0] : raw;
}

function vacancyHaystack(vac: any): string {
    if (!vac) return '';
    const og = unwrapEmbed(vac.opdrachtgever);
    const ek = unwrapEmbed(vac.eindklant);
    return [
        vac.title,
        vac.vacancy_number,
        vac.data?.location,
        vac.location,
        og?.name,
        ek?.name,
        vac.status,
    ]
        .filter((x) => x != null && String(x).trim() !== '')
        .join(' ')
        .toLowerCase();
}

export type ClientShortlistBundle = {
    applications: any[];
    interviews: any[];
    placements: any[];
    stageHistory: any[];
};

/** Filter shortlist-data op kandidaat, vacature, klant of status. */
export function filterClientShortlistBundle(
    query: string,
    applications: any[],
    interviews: any[],
    placements: any[],
    stageHistory: any[]
): ClientShortlistBundle {
    const q = query.trim().toLowerCase();
    if (!q) {
        return { applications, interviews, placements, stageHistory };
    }

    const appMatches = (app: any) => {
        const cand = app.candidates;
        return (
            vacancyHaystack(app.vacancies).includes(q) ||
            String(cand?.name || '').toLowerCase().includes(q) ||
            String(cand?.role || '').toLowerCase().includes(q) ||
            String(cand?.email || '').toLowerCase().includes(q) ||
            String(app.status || '').toLowerCase().includes(q)
        );
    };

    const filteredApps = applications.filter(appMatches);
    const matchedVacIds = new Set<string>();
    const matchedAppIds = new Set<string>();
    for (const a of filteredApps) {
        if (a?.id) matchedAppIds.add(String(a.id));
        if (a?.vacancy_id) matchedVacIds.add(String(a.vacancy_id));
    }

    const interviewMatches = (row: any) => {
        if (row.vacancy_id && matchedVacIds.has(String(row.vacancy_id))) return true;
        return (
            vacancyHaystack(row.vacancies).includes(q) ||
            String(row.status || '').toLowerCase().includes(q) ||
            String(row.location || '').toLowerCase().includes(q)
        );
    };

    const placementMatches = (p: any) => {
        if (p.vacancy_id && matchedVacIds.has(String(p.vacancy_id))) return true;
        return (
            vacancyHaystack(p.vacancies).includes(q) ||
            String(p.end_client || '').toLowerCase().includes(q) ||
            String(p.status || '').toLowerCase().includes(q)
        );
    };

    const historyMatches = (h: any) => {
        if (h.application_id && matchedAppIds.has(String(h.application_id))) return true;
        return (
            vacancyHaystack(unwrapEmbed(h.vacancies)).includes(q) ||
            String(h.stage || '').toLowerCase().includes(q) ||
            String(h.previous_stage || '').toLowerCase().includes(q)
        );
    };

    return {
        applications: filteredApps,
        interviews: interviews.filter(interviewMatches),
        placements: placements.filter(placementMatches),
        stageHistory: stageHistory.filter(historyMatches),
    };
}

export function filterClientVacanciesList(
    vacancies: any[],
    query: string,
    resolveClient?: (clientId: string | null | undefined, embed: any) => { name?: string } | null
): any[] {
    const q = query.trim().toLowerCase();
    if (!q) return vacancies;
    return vacancies.filter((v) => {
        const og = resolveClient?.(v.opdrachtgever_id, v.opdrachtgever);
        const ek = resolveClient?.(v.eindklant_id, v.eindklant);
        return (
            String(v.title || '').toLowerCase().includes(q) ||
            String(v.vacancy_number || '').toLowerCase().includes(q) ||
            String(v.location || v.data?.location || '').toLowerCase().includes(q) ||
            String(v.status || '').toLowerCase().includes(q) ||
            String(og?.name || '').toLowerCase().includes(q) ||
            String(ek?.name || '').toLowerCase().includes(q)
        );
    });
}
